export default __webpack_public_path__ + "static/media/ahs-logo.a6975ecb.png";